import AutoSuggestChips from './AutoSuggestChips';

export default AutoSuggestChips;
